import { render, staticRenderFns } from "./YoutubeModal.vue?vue&type=template&id=2188d72e&"
import script from "./YoutubeModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./YoutubeModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports